import React, {useState, useRef, Fragment} from 'react';
import { Dialog, Transition } from '@headlessui/react'

import config from '../config';
import {HashLink as Link} from 'react-router-hash-link';



export default function StakingButton({nft}) {

  return (
    config.IS_STAKING_ACTIVE ?
      <>
        <button
          className="btn btn-primary m-2 mx-auto bg-brand font-bold text-2xl text-brand-text rounded-lg w-auto hover:scale-105 hover:bg-brand-hover text-center flex"

          onClick={() => {

          }}
        >
          <Link to="/staking" className="p-2 no-underline">{nft.isStaked ? 'Unstake' : 'Stake'}</Link>

        </button>
      </> : null
  );
}
